import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import MDButton from "components/MDButton";
import { formatAddressPreview } from "utils/addressHelpers";

// eslint-disable-next-line react/prop-types
function AddressSelect({ label, value, onChange, onAddClick, addresses }) {
  return (
    <Grid container spacing={1} alignItems="center" sx={{ width: "100%", display: "flex" }}>
      <Grid item xs={10}>
        <FormControl fullWidth sx={{ minHeight: "56px" }}>
          <InputLabel id={`${label}-label`}>{label}</InputLabel>
          <Select
            labelId={`${label}-label`}
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            label={label}
            variant="outlined"
            size="medium"
            sx={{
              minHeight: "56px",
              "& .MuiOutlinedInput-notchedOutline": {
                borderRadius: "4px",
              },
              "& .MuiSelect-select": {
                padding: "16px 14px",
                minHeight: "56px",
                display: "flex",
                alignItems: "center",
              },
            }}
          >
            <MenuItem value="" sx={{ minHeight: "48px" }}>
              -- Select {label} --
            </MenuItem>
            {addresses &&
              addresses.map((addr) => (
                <MenuItem key={addr.id} value={addr.id} sx={{ minHeight: "48px" }}>
                  {formatAddressPreview(addr)}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={2} sx={{ display: "flex" }}>
        <MDButton variant="outlined" size="small" color="info" onClick={onAddClick} fullWidth>
          + Add
        </MDButton>
      </Grid>
    </Grid>
  );
}

AddressSelect.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onAddClick: PropTypes.func.isRequired,
  addresses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      city: PropTypes.string,
      state: PropTypes.string,
    })
  ),
};

AddressSelect.defaultProps = {
  value: null,
  addresses: [],
};

export default AddressSelect;
